import React, { useState } from 'react';
import { pdf } from '@react-pdf/renderer';
import BollaPDF from './BollaPDF';

export default function BottoneVisualizzaBollaPDF({ bolla }) {
  const [loading, setLoading] = useState(false);

  async function apriPDF() {
    setLoading(true);
    try {
      const blob = await pdf(<BollaPDF bolla={bolla} />).toBlob();
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
      setTimeout(() => URL.revokeObjectURL(url), 10000);
    } catch (err) {
      alert('Errore generazione PDF: ' + err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <button
      onClick={apriPDF}
      disabled={loading}
      title="Visualizza bolla PDF"
      style={{
        background: 'none',
        border: 'none',
        cursor: loading ? 'wait' : 'pointer',
        padding: '4px 8px',
        borderRadius: '6px',
        fontSize: '22px',
        lineHeight: 1,
        transition: 'transform 0.15s',
      }}
      onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.2)'}
      onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
    >
      {loading ? '⏳' : (
        <img alt="PDF" src="/icon-pdf.svg" style={{ width: 40, verticalAlign: 'middle' }} />
      )}
    </button>
  );
}